import store from '~/Library/store'

export const viewCard = (id) => () => {
  store.setAttribute('card_index', id)
}
